import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEyeNone = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2438 2.51046C14.4521 2.30218 14.4521 1.9645 14.2438 1.75622C14.0355 1.54793 13.6978 1.54793 13.4895 1.75622L11.395 3.8508C10.3536 3.43117 9.21343 3.20001 8 3.20001C4.59505 3.20001 1.76682 5.02015 0.0810669 7.71735C-0.0270227 7.8903 -0.0270223 8.10975 0.0810682 8.28269C0.963141 9.694 2.15802 10.8652 3.58465 11.6611L1.75621 13.4895C1.54793 13.6978 1.54793 14.0355 1.75621 14.2438C1.96449 14.4521 2.30218 14.4521 2.51045 14.2438L4.60505 12.1492C5.64638 12.5689 6.78657 12.8 8 12.8C11.4049 12.8 14.2332 10.9798 15.9189 8.28269C16.027 8.10975 16.027 7.8903 15.9189 7.71735C15.0369 6.30604 13.842 5.13485 12.4154 4.3389L14.2438 2.51046ZM10.5646 4.68119C9.76354 4.41185 8.9041 4.26668 8 4.26668C5.12304 4.26668 2.69815 5.73671 1.1693 8.00002C1.9977 9.22636 3.08916 10.2198 4.37306 10.8726L10.5646 4.68119ZM5.43543 11.3188L11.627 5.12732C12.9108 5.78021 14.0023 6.77367 14.8307 8.00002C13.3019 10.2633 10.8769 11.7333 8 11.7333C7.0959 11.7333 6.23646 11.5882 5.43543 11.3188Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgEyeNone)
const IconSvgEyeNone = createIcon(ForwardRef, 'SvgEyeNone')
export default IconSvgEyeNone
